import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-moon",
  "use": "icon-moon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-moon\"><path d=\"M897.387 595.477a21.376 21.376 0 0 0-23.638-3.306 358.827 358.827 0 0 1-159.082 37.162C514.688 629.333 352 466.645 352 266.667c0-41.792 7.488-83.542 22.25-124.032a21.312 21.312 0 0 0-29.44-26.454C204.502 184.896 117.334 324.31 117.334 480c0 223.51 181.824 405.333 405.334 405.333 169.408 0 322.325-107.157 380.501-266.688a21.333 21.333 0 0 0-5.781-23.168z m-374.72 247.19C322.688 842.667 160 679.979 160 480c0-121.899 59.755-232.661 158.848-299.627a397.163 397.163 0 0 0-9.515 86.294C309.333 490.176 491.157 672 714.667 672c43.562 0 86.165-6.933 127.232-20.715-62.507 116.267-185.088 191.382-319.232 191.382z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/moon.svg
// module id = Ux9W
// module chunks = 65